import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/tutorial', label: '教程攻略' },
    { to: '/category/news', label: '更新动态' },
    { to: '/about', label: '关于我们' },
  ];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-2 cursor-pointer whitespace-nowrap"
          >
            <span className="font-heading text-2xl text-primary-500">KY</span>
            <span className={`text-sm font-medium transition-colors duration-300 ${scrolled ? 'text-foreground-900' : 'text-white'}`}>
              www.ky.app
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                  isActive(link.to)
                    ? 'text-primary-500'
                    : scrolled
                      ? 'text-foreground-700 hover:text-primary-500'
                      : 'text-white/90 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="#download"
              className="px-5 py-2 rounded-full bg-primary-500 text-white text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors duration-200"
            >
              立即下载
            </a>
          </div>

          {/* Mobile toggle */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
            aria-label="Toggle menu"
          >
            <i
              className={`text-xl transition-colors duration-200 ${
                scrolled ? 'text-foreground-900' : 'text-white'
              } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 pb-4 pt-2">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`block px-4 py-3 text-sm font-medium whitespace-nowrap ${
                  isActive(link.to)
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="px-4 pt-3">
              <a
                href="#download"
                className="block w-full text-center px-5 py-2.5 rounded-full bg-primary-500 text-white text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                立即下载
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}